import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

const PreconditionsSkeletonScreen = () => (
    <div>
        <ContentLoader height={14} width={300} className="margin-bottom-15" />
        <ContentLoader height={14} width={'100%'} className="margin-bottom-10" />
        <ContentLoader height={14} width={'100%'} className="margin-bottom-10" />
        <ContentLoader height={14} width={'100%'} className="margin-bottom-10" />
        <ContentLoader height={14} width={'100%'} className="margin-bottom-10" />
        <ContentLoader height={14} width={'100%'} />
    </div>
);

export default PreconditionsSkeletonScreen;
